<template>
  <div>
    <h3 class="text-lg">Pipeline Stage</h3>
    <div class="mt-4">
      <div
        class="-mx-6 px-6 space-y-2 py-4"
        :class="[selectedFilter === 'has_pipeline_stage' ? 'bg-blue-50' : 'bg-white']"
      >
        <div class="flex items-center">
          <input
            type="radio"
            v-model="selectedFilter"
            name="pipeline_stage"
            id="has_pipeline_stage"
            value="has_pipeline_stage"
          />
          <label
            for="has_pipeline_stage"
            class="ml-3 block text-sm font-medium text-gray-700 select-none"
            >Doesnt have Pipeline stage</label
          >
        </div>
      </div>

      <div
        class="-mx-6 px-6 space-y-2 py-4"
        :class="[selectedFilter === 'pipeline_stage_name_is' ? 'bg-blue-50' : 'bg-white']"
      >
        <div class="flex items-center">
          <input
            type="radio"
            v-model="selectedFilter"
            name="pipeline_stage"
            id="pipeline_stage_name_is"
            value="pipeline_stage_name_is"
          />
          <label
            for="pipeline_stage_name_is"
            class="ml-3 block text-sm font-medium text-gray-700 select-none"
            >Pipeline stage is</label
          >
        </div>
        <BaseChipsBasic
          v-show="selectedFilter === 'pipeline_stage_name_is'"
          v-model="valueByPipelineStage.pipeline_stage_name_is"
          :options="pipelineStageOptions"
        />
      </div>

      <div
        class="-mx-6 px-6 space-y-2 py-4"
        :class="[selectedFilter === 'pipeline_stage_name_is_not' ? 'bg-blue-50' : 'bg-white']"
      >
        <div class="flex items-center">
          <input
            type="radio"
            v-model="selectedFilter"
            name="pipeline_stage"
            id="pipeline_stage_name_is_not"
            value="pipeline_stage_name_is_not"
          />
          <label
            for="pipeline_stage_name_is_not"
            class="ml-3 block text-sm font-medium text-gray-700 select-none"
            >Pipeline stage is not</label
          >
        </div>
        <BaseChipsBasic
          v-show="selectedFilter === 'pipeline_stage_name_is_not'"
          v-model="valueByPipelineStage.pipeline_stage_name_is_not"
          :options="pipelineStageOptions"
        />
      </div>

      <div
        class="-mx-6 px-6 space-y-2 py-4"
        :class="[selectedFilter === 'pipeline_stage_name_in' ? 'bg-blue-50' : 'bg-white']"
      >
        <div class="flex items-center">
          <input
            type="radio"
            v-model="selectedFilter"
            name="pipeline_stage"
            id="pipeline_stage_name_in"
            value="pipeline_stage_name_in"
          />
          <label
            for="pipeline_stage_name_in"
            class="ml-3 block text-sm font-medium text-gray-700 select-none"
            >Pipeline stage is one of</label
          >
        </div>
        <BaseChipsBasic
          v-show="selectedFilter === 'pipeline_stage_name_in'"
          v-model="valueByPipelineStage.pipeline_stage_name_in"
          :options="pipelineStageOptions"
          multiple
        />
      </div>

      <div
        class="-mx-6 px-6 space-y-2 py-4"
        :class="[selectedFilter === 'pipeline_stage_name_not_in' ? 'bg-blue-50' : 'bg-white']"
      >
        <div class="flex items-center">
          <input
            type="radio"
            v-model="selectedFilter"
            name="pipeline_stage"
            id="pipeline_stage_name_not_in"
            value="pipeline_stage_name_not_in"
          />
          <label
            for="pipeline_stage_name_not_in"
            class="ml-3 block text-sm font-medium text-gray-700 select-none"
            >Pipeline stage is not one of</label
          >
        </div>
        <BaseChipsBasic
          v-show="selectedFilter === 'pipeline_stage_name_not_in'"
          v-model="valueByPipelineStage.pipeline_stage_name_not_in"
          :options="pipelineStageOptions"
          multiple
        />
      </div>
    </div>
    <div class="mt-5 flex space-x-3">
      <div class="flex-none">
        <button
          type="button"
          class="relative inline-flex items-center px-4 py-2 border text-sm font-medium rounded-md bg-white focus:outline-none border-gray-300 text-gray-700 hover:bg-gray-50 focus:border-blue-600"
          @click="$emit('cancel')"
        >
          Cancel
        </button>
      </div>
      <div class="flex-1">
        <button
          type="button"
          class="w-full relative text-center items-center px-4 py-2 text-sm font-medium rounded-md bg-blue-600 text-white border border-transparent focus:outline-none focus:ring ring-blue-500 ring-opacity-50 focus:border-blue-700"
          @click="applyFilter"
        >
          Apply Filter
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ApiClient } from '@/api/client';
import {
  FILTER_PIPELINE_STAGE_NAME_IS,
  FILTER_PIPELINE_STAGE_NAME_IS_NOT,
  FILTER_PIPELINE_STAGE_NAME_IN,
  FILTER_PIPELINE_STAGE_NAME_NOT_IN,
  FILTER_HAS_PIPELINE_STAGE,
} from './filter-options';

const client = new ApiClient('/api/v1');

export default {
  data() {
    return {
      selectedFilter: null,
      pipelineStageOptions: [],
      valueByPipelineStage: {
        [FILTER_HAS_PIPELINE_STAGE]: false,
        [FILTER_PIPELINE_STAGE_NAME_IS]: null,
        [FILTER_PIPELINE_STAGE_NAME_IS_NOT]: null,
        [FILTER_PIPELINE_STAGE_NAME_IN]: [],
        [FILTER_PIPELINE_STAGE_NAME_NOT_IN]: [],
      },
    };
  },
  created() {
    this.fetchPipelineStageNames();
  },
  methods: {
    async fetchPipelineStageNames() {
      try {
        const response = await client.get(
          `accounts/${this.$route.params.accountId}/distinct-pipeline-stage-names`,
          {
            params: {
              filter: {
                project_in: this.$route.params.projectId,
              },
            },
          }
        );

        this.pipelineStageOptions = (response?.data?.data || []).map((item) => ({
          value: item.name,
          label: item.name,
        }));
      } catch (error) {
        //
      }
    },
    applyFilter() {
      this.$emit('apply-filter', {
        key: this.selectedFilter,
        value: this.valueByPipelineStage[this.selectedFilter],
      });
    },
  },
};
</script>
